import { render, staticRenderFns } from "./page003.vue?vue&type=template&id=2797e36e&scoped=true&"
import script from "./page003.vue?vue&type=script&lang=js&"
export * from "./page003.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2797e36e",
  null
  
)

export default component.exports